import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { required } from '@gig/magic-form-builder';

function singleChoice(question) {
    var _this = this;
    return {
        id: question.text + '-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        isOptional: question.isOptional,
        children: [
            {
                id: question.text,
                component: 'magic-ui-dropdown',
                isDataField: true,
                properties: {
                    placeholder: translate('questionnaire.single-choice-answer'),
                },
                validation: [
                    {
                        name: 'required',
                        fn: required,
                    },
                ],
                preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, {
                                options: question.answerChoices.map(function (_a) {
                                    var text = _a.text;
                                    return ({
                                        name: text,
                                        value: text,
                                    });
                                }),
                            }];
                    });
                }); },
            },
        ],
    };
}

export { singleChoice };
